import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { Reorder } from 'framer-motion';
import classNames from 'classnames';
import { image } from '../../../../utils/data/baseUrl';

const QuizItemReorderItem = React.forwardRef(function QuizItemReorderItem({ id, item, activeId, setActiveId }, ref) {
  return (
    <Reorder.Item
      key={item.id}
      value={item}
      onDragStart={() => setActiveId(item.text)}
      onDragEnd={() => setActiveId(null)}
    >
      <div
        className={classNames('quiz__item-option', {
          'quiz__item-option_active': item.text === activeId,
        })}
      >
        <div className={'quiz__item-option-text'}>{safeHTML(item?.text)}</div>
        <img className={'quiz__item-option-icon'} src={image('quiz/drag.svg')} alt={'draggable-icon'} />
      </div>
    </Reorder.Item>
  );
});

export default QuizItemReorderItem;
QuizItemReorderItem.propTypes = {};
